module.exports = __webpack_public_path__ + "static/media/add_employee.0e75f244.svg";